import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import AuthContext from '../../../../../authentication/AuthContext';
import { Button } from 'react-bootstrap';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

import ProductImage from '../../../../../common/ProductImage';
import CarouselProductCard from './CarouselProductCard';
import OrderContext from '../../../OrderContext';
import { IconWrapper } from '../../../../../common/IconWrapper';

export default function AdvertisingCarousel({ productCodes, upsoldFrom }) {
    const cas = useContext(AuthContext);
    const { orderId } = useContext(OrderContext);
    const [products, setProducts] = useState([]);
    const [displayedProducts, setDisplayedProducts] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    const showsForgottenProducts = upsoldFrom === 'Forgotten';

    function removeProductFromCarousel(productCode) {
        let index = productCodes.indexOf(productCode);

        while (index > -1) {
            productCodes.splice(index, 1);
            index = productCodes.indexOf(productCode);
        }

        refreshProductInfo();
    }

    let refreshProductInfo = () => {
        if (productCodes.length === 0) {
            setProducts([]);
        } else {
            axios
                .get(
                    window.CONFIG['ws.activoc-web-order-api.advertising.products'].replace(
                        '{orderId}',
                        orderId
                    ),
                    {
                        params: {
                            productCodes: productCodes.join()
                        },
                        headers: {
                            Authorization: cas,
                            'Content-Type': 'application/json'
                        }
                    }
                )
                .then(response => {
                    setProducts(response.data);
                });
        }
    };

    useEffect(refreshProductInfo, [cas]);

    useEffect(() => {
        let newDisplayedProducts = [];
        newDisplayedProducts.push(products[currentIndex] ? products[currentIndex] : null);
        newDisplayedProducts.push(products[currentIndex + 1] ? products[currentIndex + 1] : null);
        newDisplayedProducts.push(products[currentIndex + 2] ? products[currentIndex + 2] : null);
        newDisplayedProducts.push(products[currentIndex + 3] ? products[currentIndex + 3] : null);
        setDisplayedProducts(newDisplayedProducts);
    }, [currentIndex, products]);

    return (
        <div>
            {showsForgottenProducts && (
                <div className="col-sm-12 carousel-headline">
                    <h5>Other products to consider...</h5>
                    <p>If you want to tailor future suggestions, remove products from the carousel.</p>
                </div>
            )}
            <div className={'carousel-wrapper flex'}>
                <Button
                    onClick={() => setCurrentIndex(currentIndex - 1)}
                    disabled={currentIndex === 0}
                    data-testid={'carousel-previous'}
                >
                    <IconWrapper icon={faChevronLeft} />
                </Button>
                {displayedProducts &&
                    displayedProducts.map(product => (
                        <div
                            className={'product-card flex'}
                            data-testid={'product-card-' + (product ? product.productCode : 'empty')}
                            key={product ? product.productCode : Math.random()}
                        >
                            {product && (
                                <CarouselProductCard
                                    product={product}
                                    upsoldFrom={upsoldFrom}
                                    refreshCarouselInfo={refreshProductInfo}
                                    removeProductFromCarousel={removeProductFromCarousel}
                                />
                            )}
                        </div>
                    ))}
                <Button
                    onClick={() => setCurrentIndex(currentIndex + 1)}
                    disabled={currentIndex >= products.length - 4}
                    data-testid={'carousel-next'}
                >
                    <IconWrapper icon={faChevronRight} />
                </Button>
            </div>
            <div className={'carousel-nav flex'} data-testid={'carousel-nav'}>
                {products.map((product, index) => (
                    <button
                        onClick={() => setCurrentIndex(index)}
                        data-testid={'carousel-nav-' + product.productCode}
                        key={product.productCode}
                    >
                        <ProductImage
                            src={product.image}
                            alt={'Nav image for: ' + product.productDescription}
                        />
                    </button>
                ))}
            </div>
        </div>
    );
}
